/* TXBERSERKER — theme.js */

document.addEventListener('DOMContentLoaded', () => {

  /* ── SCROLL REVEAL ── */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => observer.observe(el));
  }

  /* ── UPDATE CART COUNT ── */
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      const el = document.getElementById('cart-count');
      if (el) el.textContent = data.item_count;
    } catch(e) {}
  }

  /* ── PRODUCT PAGE ── */
  const productForm = document.getElementById('product-form');
  if (productForm) {

    // Load variant and image data
    let variants = [];
    let images = [];
    try {
      const vData = document.getElementById('product-variants-json');
      const iData = document.getElementById('product-images-json');
      if (vData) variants = JSON.parse(vData.textContent);
      if (iData) images = JSON.parse(iData.textContent);
    } catch(e) {}

    // Track selected options
    const numOptions = document.querySelectorAll('.product-option').length;
    const selectedOptions = {};

    // Init selected options from active buttons
    document.querySelectorAll('.option-btn.active').forEach(btn => {
      selectedOptions[btn.dataset.optionIndex] = btn.dataset.value;
    });

    // Find matching variant from selected options
    function findVariant() {
      return variants.find(v =>
        v.options.every((opt, i) => selectedOptions[String(i)] === opt)
      );
    }

    // Find image for a variant
    function findImageForVariant(variantId) {
      return images.find(img =>
        img.variant_ids && img.variant_ids.includes(variantId)
      );
    }

    // Swap main product image
    function swapImage(src) {
      const mainImg = document.getElementById('main-product-img');
      if (mainImg && src) {
        mainImg.src = src;
        // Update active thumb
        document.querySelectorAll('.product-thumb').forEach(t => {
          t.classList.toggle('active', t.dataset.src === src);
        });
      }
    }

    // Update price display
    function updatePrice(variant) {
      const priceEl = document.getElementById('product-price');
      if (!priceEl || !variant) return;
      const price = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      const compare = variant.compare_at_price ? (variant.compare_at_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : null;
      if (compare && variant.compare_at_price > variant.price) {
        priceEl.innerHTML = '<span class="price-sale">' + price + '</span><span class="price-compare">' + compare + '</span>';
      } else {
        priceEl.innerHTML = '<span>' + price + '</span>';
      }
    }

    // Update ATC button state
    function updateATCBtn(variant) {
      const btn = document.getElementById('atc-btn');
      const avail = document.getElementById('product-availability');
      if (!btn) return;
      if (!variant) {
        btn.textContent = 'Unavailable';
        btn.disabled = true;
      } else if (!variant.available) {
        btn.textContent = 'Sold Out';
        btn.disabled = true;
        if (avail) avail.textContent = 'This variant is sold out.';
      } else {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
        if (avail) avail.textContent = '';
      }
    }

    // Handle option button clicks
    document.querySelectorAll('.option-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = btn.dataset.optionIndex;
        const val = btn.dataset.value;

        // Update active state in this option group
        document.querySelectorAll('.option-btn[data-option-index="' + idx + '"]').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        // Update selected label
        const label = document.getElementById('option-selected-' + idx);
        if (label) label.textContent = val;

        // Track selection
        selectedOptions[idx] = val;

        // Find matching variant
        const variant = findVariant();
        if (variant) {
          // Update hidden variant ID
          document.getElementById('variant-id').value = variant.id;

          // Swap image if this variant has one
          const img = findImageForVariant(variant.id);
          if (img) swapImage(img.src);

          // Update price + button
          updatePrice(variant);
          updateATCBtn(variant);
        } else {
          updateATCBtn(null);
        }
      });
    });

    // Thumbnail click to swap image
    document.querySelectorAll('.product-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        swapImage(thumb.dataset.src);
      });
    });

    // SUBMIT — Add to Cart via AJAX
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = document.getElementById('atc-btn');
      const variantId = document.getElementById('variant-id').value;
      if (!variantId) return;

      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });

        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.description || 'Could not add to cart');
        }

        btn.textContent = 'Added ✦';
        updateCartCount();

        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        }, 2000);

      } catch(err) {
        btn.textContent = err.message || 'Error — Try Again';
        btn.disabled = false;
      }
    });
  }

  /* ── CART PAGE CHECKOUT ── */
  const checkoutBtn = document.getElementById('checkout-btn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.href = '/checkout';
    });
  }

  /* ── HOMEPAGE QUICK ADD ── */
  document.querySelectorAll('.quick-add[data-product-id]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.productId;
      const original = btn.textContent;
      btn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });
        if (!res.ok) throw new Error();
        btn.textContent = 'Added ✦';
        updateCartCount();
        setTimeout(() => { btn.textContent = original; }, 1800);
      } catch {
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = original; }, 1800);
      }
    });
  });

});
